import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${({ color }) => color};
  margin: 32px 0;
`;
